import * as actions from './actions';
import * as util from './util';
import reducers from './reducers';
import * as selectors from './selectors';

const methods = {
    actions: actions,
    util: util,
    reducer: reducers,
    selectors: selectors
};

export default methods;